import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import '@angular/compiler';
import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, NgModule } from "@angular/core";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UpgradeModule } from '@angular/upgrade/static';
import {
    bindCoreToAngularJs,
    CoreModule,
} from '@core/core.module';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';
import { customTooltipOptions } from '@core/settings/mat-tootip.settings';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import {
    AngularjsAngularExamplesModule,
    bindAngularjsAngularExamplesToAngularJs,
} from './components/angularjs-angular-examples/angularjs-angular-examples.module';
import { bindPlannerViewToAngularJS, DeliveryOrderPlannerModule } from './feature-modules/planner-features/delivery-order-planner/delivery-order-planner.module';
import { bindOrderDeliveryViewToAngularJS, OrderDeliveryModule } from './feature-modules/planner-features/order-delivery/order-delivery.module';
import { AuthorizationExporedInterceptor } from '@core/interceptors/ng-authorization-expired.interceptor';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        // Provide angular upgrade capabilities
        UpgradeModule,
        // Provides the @uirouter/angular directives and registers
        // the future state for the lazy loaded contacts module
        UIRouterUpgradeModule.forRoot(),

        CoreModule,
        AngularjsAngularExamplesModule,
        DeliveryOrderPlannerModule,
        OrderDeliveryModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthorizationExporedInterceptor,
            multi: true
        },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: customTooltipOptions },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } },
    ],
})
export class AppModule implements DoBootstrap {
    constructor(private upgrade: UpgradeModule) { }
    ngDoBootstrap() {
        this.upgrade.bootstrap(document.body, ['smartApp'], { strictDi: false });
    }
}

export function bindToAngularJs(angular: any) {
    // Include all bindings to AngularJs from imported modules
    bindAngularjsAngularExamplesToAngularJs(angular);
    bindPlannerViewToAngularJS(angular);
    bindOrderDeliveryViewToAngularJS(angular);
    bindCoreToAngularJs(angular);
}
